import React, { ReactNode } from 'react';
import logo from '../../../assets/orderx-logo.svg';
import styled from 'styled-components';
import ReactDOM from 'react-dom';
import { Mask } from 'antd-mobile';

const Wrapper = styled.div`
    height: 100vh;
    width: 100vw;
    display: grid;
    align-content: center;
    justify-content: center;
    text-align: center;
    gap: 4rem;
    color: white;
    font-size: var(--rx-font-size-lg);

    .loader {
        width: 200px;
        height: 200px;
        position: relative;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
            height: 24px;
        }
    }

    .loader::after,
    .loader::before {
        content: '';
        box-sizing: border-box;
        width: inherit;
        height: inherit;
        border: 2px solid var(--adm-color-primary);
        border-radius: 20px;
        box-shadow: 0 0 4px var(--adm-color-primary);
        position: absolute;
        left: 0;
        top: 0;
        animation: rotationBreak 3s ease-in-out infinite alternate;
    }

    .loader::after {
        border-color: var(--rx-color-secondary);
        box-shadow: 0 0 4px var(--rx-color-secondary);
        animation-direction: alternate-reverse;
    }

    @keyframes rotationBreak {
        0% {
            transform: rotate(0);
        }
        25% {
            transform: rotate(90deg);
        }
        50% {
            transform: rotate(180deg);
        }
        75% {
            transform: rotate(270deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
`;

type Input = {
    content?: ReactNode;
};

export function OverlayLoading(input: Input) {
    return ReactDOM.createPortal(
        <Mask style={{ background: 'var(--rx-layer-dark)' }}>
            <Wrapper>
                <div className={'loader'}>
                    <img src={logo} alt={'OrderX'} />
                </div>

                {input.content && <div>{input.content}</div>}
            </Wrapper>
        </Mask>,
        document.documentElement,
    );
}
